<template>
	<view>
		富文本
	</view>
</template>

<script>
	export default {
		onLoad(option) {
			uni.setNavigationBarTitle({
				title: option.title
			});
		}
	}
</script>

<style lang="less" scoped>
	
</style>